import { render, staticRenderFns } from "./CompraFalcon.vue?vue&type=template&id=e5f2ce34&"
import script from "./CompraFalcon.vue?vue&type=script&lang=js&"
export * from "./CompraFalcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports